<template>
	<div class="">
		<div class="fenbuBox">
			<div class="zhuanye" id="renshu"></div>
		</div>
	</div>
</template>

<script>

	export default {
		name: "",
		components: {
			
		},
		data() {
			return {}
		},
		mounted(){
			var myChart = this.$echarts.init(document.getElementById('renshu'));
				var option = {
				    tooltip: {
				        trigger: 'axis'
				    },
				    legend: {
				        color: ["#29A7E1", "#FE9603", "#D326F4", "#00B10C"],
				        data: ['计算机', '金融', '服务', '教育'],
				        left: 'center',
				        bottom: 'bottom'
				    },
				    grid: {
				        top: 'middle',
				        left: '3%',
				        right: '4%',
				        bottom: '3%',
				        height: '80%',
				        containLabel: true
				    },
				    xAxis: {
				        type: 'category',
				        data: ['2010年','2011年','2012年','2013年','2014年','2015年','2016年','2017年','2018年','2019年','2020年','2021年'],
				        axisLine: {
				            lineStyle: {
				                color: "#999"
				            }
				        }
				    },
				    yAxis: {
				        type: 'value',
						name: '人数',
				
				        splitLine: {
				            lineStyle: {
				                type: 'dashed',
				                color: '#333333'
				            }
				        },
				        axisLine: {
				            show: false,
				            lineStyle: {
				                color: "#333"
				            },
				        },
				        nameTextStyle: {
				            color: "#999"
				        },
				        splitArea: {
				            show: false
				        }
				    },
				    series: [{
				            name: '计算机',
				            type: 'line',
				            data: [500,900,220,130,660,289,900,220,130,660,289,289],
				            color: "#29A7E1",
				            lineStyle: {
				                normal: {
				                    width:2,
				                    color: {
				                        type: 'linear',
				
				                        colorStops: [{
				                            offset: 0,
				                            color: '#29A7E1' // 0% 处的颜色
				                        }, {
				                            offset: 0.4,
				                            color: '#29A7E1' // 100% 处的颜色
				                        }, {
				                            offset: 1,
				                            color: '#29A7E1' // 100% 处的颜色
				                        }],
				                        globalCoord: false // 缺省为 false
				                    },
				                    shadowColor: '#29A7E1',
				                    shadowBlur:5,
				                    shadowOffsetY: 7
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#29A7E1',
				                    borderWidth: 5,
				                    /*shadowColor: 'rgba(72,216,191, 0.3)',
				                     shadowBlur: 100,*/
				                    borderColor: "#29A7E1"
				                }
				            },
				            smooth: true
				        },
				        {
				            name: '金融',
				            type: 'line',
				            data: [123,568,111,222,123,56,568,111,222,123,56,156],
				            lineStyle: {
				                normal: {
				                    width:2,
				                    color: {
				                        type: 'linear',
				
				                        colorStops: [{
				                                offset: 0,
				                                color: '#FE9603' // 0% 处的颜色
				                            },
				                            {
				                                offset: 0.4,
				                                color: '#FE9603' // 100% 处的颜色
				                            }, {
				                                offset: 1,
				                                color: '#FE9603' // 100% 处的颜色
				                            }
				                        ],
				                        globalCoord: false // 缺省为 false
				                    },
				                    shadowColor: '#FE9603',
				                    shadowBlur:5,
				                    shadowOffsetY: 7
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#FE9603',
				                    borderWidth: 5,
				                    /*shadowColor: 'rgba(72,216,191, 0.3)',
				                     shadowBlur: 100,*/
				                    borderColor: "#FE9603"
				                }
				            },
				            smooth: true
				        },
				        {
				            name: '服务',
				            type: 'line',
				            data: [125,568,25,36,784,56,36,784,56,36,784,56],
				            lineStyle: {
				                normal: {
				                    width: 2,
				                    color: {
				                        type: 'linear',
				
				                        colorStops: [{
				                                offset: 0,
				                                color: '#D326F4' // 0% 处的颜色
				                            },
				                            {
				                                offset: 0.4,
				                                color: '#D326F4' // 100% 处的颜色
				                            }, {
				                                offset: 1,
				                                color: '#D326F4' // 100% 处的颜色
				                            }
				                        ],
				                        globalCoord: false // 缺省为 false
				                    },
				                    shadowColor: '#D326F4',
				                    shadowBlur: 5,
				                    shadowOffsetY: 7
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#D326F4',
				                    borderWidth: 5,
				                    /*shadowColor: 'rgba(72,216,191, 0.3)',
				                     shadowBlur: 100,*/
				                    borderColor: "#D326F4"
				                }
				            },
				            smooth: true
				        },
						{
						    name: '教育',
						    type: 'line',
						    data: [56,36,784,56,125,568,25,36,784,56,36,784,],
						    lineStyle: {
						        normal: {
						            width: 2,
						            color: {
						                type: 'linear',
							
						                colorStops: [{
						                        offset: 0,
						                        color: '#00B10C' // 0% 处的颜色
						                    },
						                    {
						                        offset: 0.4,
						                        color: '#00B10C' // 100% 处的颜色
						                    }, {
						                        offset: 1,
						                        color: '#00B10C' // 100% 处的颜色
						                    }
						                ],
						                globalCoord: false // 缺省为 false
						            },
						            shadowColor: '#00B10C',
						            shadowBlur: 5,
						            shadowOffsetY: 7
						        }
						    },
						    itemStyle: {
						        normal: {
						            color: '#00B10C',
						            borderWidth: 5,
						            /*shadowColor: 'rgba(72,216,191, 0.3)',
						             shadowBlur: 100,*/
						            borderColor: "#00B10C"
						        }
						    },
						    smooth: true
						}
				    ]
				};
			// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
		},
		methods: {
			
		}


	}
</script>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/tubiao/xueshengjiuye.vue